import { render } from "./WelcomeTopBar.vue?vue&type=template&id=59a00004&scoped=true"
import script from "./WelcomeTopBar.vue?vue&type=script&lang=js"
export * from "./WelcomeTopBar.vue?vue&type=script&lang=js"

import "./WelcomeTopBar.vue?vue&type=style&index=0&id=59a00004&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a00004"]])

export default __exports__